// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import moment from 'moment';

type Props = {
  // This is the amount of hours given to do a job
  // Units: hours, ex: 1, 2
  // hours: number,
  // The time that the job was issued
  // Units: milliseconds, ex: 1531426768595
  // createdAt: number,

  expiresAt?: ?number;
  // Disabled: this means it will be 00:00:00
  disabled?: boolean;
  // When the time is up it will trigger this function
  handleTimeUp?: () => void;
};

type State = {
  // Units: milliseconds
  remainingTime: number;
};

const HOURS_TO_MILLIS_CONSTANT = 3600 * 1000;

export default class CountDown extends Component<Props, State> {
  interval: IntervalID;
  timeUp: boolean = false;

  constructor(props: Props) {
    super(props);
    // const remainingTime = (props.createdAt + (props.hours * HOURS_TO_MILLIS_CONSTANT)) - Date.now();
    const n = Date.now();
    const remainingTime = typeof props.expiresAt === 'number' && props.expiresAt > n ? props.expiresAt - n : 0;
    this.state = {
      remainingTime,
    };
  }

  componentDidMount() {
    const { handleTimeUp } = this.props;
    if (this.state.remainingTime > 0) {
      this.interval = setInterval(() =>
        this.setState((state: State) => {
          if (state.remainingTime < 0 && handleTimeUp && !this.timeUp) {
            this.timeUp = true;
            handleTimeUp();
          }
          return ({
            remainingTime: state.remainingTime - 1000,
          })
        }), 1000);
    } else if (handleTimeUp) {
      handleTimeUp();
    }
  }

  componentWillUnmount() {
    if (typeof this.interval === 'number') {
      clearInterval(this.interval);
    }
  }

  render() {
    const { remainingTime } = this.state;
    const { disabled } = this.props;
    if (disabled || remainingTime < 0) {
      return (
        <span>00:00:00</span>
      );
    }
    const tempTime = moment.duration(remainingTime);
    const hours = tempTime.hours() < 10 ? `0${tempTime.hours()}` : tempTime.hours();
    const minutes = tempTime.minutes() < 10 ? `0${tempTime.minutes()}` : tempTime.minutes();
    const seconds = tempTime.seconds() < 10 ? `0${tempTime.seconds()}` : tempTime.seconds();
    return (
      <span>{hours}:{minutes}:{seconds}</span>
    );
  }
}

CountDown.propTypes = {
  // hours: PropTypes.number.isRequired,
  expiresAt: PropTypes.number,
  disabled: PropTypes.bool,
  handleTimeUp: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/elements/CountDown/CountDown.jsx